import React, { Component } from "react";
import Iframe from "react-iframe";
import { NavLink } from "react-router-dom";
import "./Home.scss";
import CountUp from "react-countup";
import Card from "../common/card/card";
import VisibilitySensor from "react-visibility-sensor";
import OwlCarousel from "react-owl-carousel";
import axios from "axios";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import imgurl from "../../images/Advance programming.png";
const options = {
  rewind: true,
  autoplay: true,
  responsive: {
    0: {
      items: 1,
    },
    700: {
      items: 2,
    },
    1000: {
      items: 3,
    },
  },
};

class Home extends Component {
  constructor() {
    super();
    this.scrollPage();

    this.state = {
      email: "",
      phone: "",
      events: "Free Demo session for Oracle RAC on 7-03-2020 at 1 pm",
    };
  }

  scrollPage() {
    window.scrollTo({
      top: 0,
    });
  }

  onChange = (e) => {
    /*
      Because we named the inputs to match their
      corresponding values in state, it's
      super easy to update the state
    */
    this.setState({ [e.target.name]: e.target.value });
  };
  onSubmit = (e) => {
    e.preventDefault();
    // get our form data out of state
    const { email, phone } = this.state;
    const type = "home";
    const subject = "Inquery Email";
    const to = "info@logipool.in";
    const from = "logipooltraining@gmail.com";

    axios
      .post("http://167.99.234.75:54312/email/sendEmail", {
        email,
        phone,
        type,
        subject,
        to,
        from,
      })
      .then((result) => {
        //access the results here....
        alert("Thank you so much....! we will contact you.");
        this.setState({
          email: "",
          phone: "",
        });
      });
  };

  render() {
    const { email, phone } = this.state;
    return (
      <div className="home">
        {/* page 1 */}
        <div className="page1">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="heading">
                  <h1>
                    Take the first step <br /> to learn with Logipool
                  </h1>
                  <p>
                    Ask it , Get it !
                    <br />
                    Want it , Have it !
                  </p>
                </div>
              </div>
              <div className="col-md-6 pageonelogo">
                <img src={require("../../images/traning logo.png")} alt="" />
              </div>
            </div>
          </div>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-md-3">
                <div className="page-1-info">
                  <div className="icon">
                    <img
                      src={require("../../images//trophy icon.png")}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <h1>Top Courses</h1>
                    <p>
                      Get the finest advance courses that are in demand now.
                    </p>

                    <a href="">Join Us</a>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="page-1-info">
                  <div className="icon">
                    <img
                      src={require("../../images/placement icon.png")}
                      alt=""
                    />
                  </div>

                  <div className="info">
                    <h1>Upcoming Events</h1>
                    <p>{this.state.events}</p>
                    <NavLink to="/contact" activeClassName="active">
                      Join Us
                    </NavLink>
                    {/* <a href="">Join Us</a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* page 2 */}
        <section className="page2">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 ">
                <div className="page2_heading">
                  <h1>In-Demand Courses</h1>
                  <p>
                    We are known for creating courses on latest technologies
                    with projects. This gives students a confidence in learning.
                    You can learn coding only by building stuff.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            {/* <div className="row">
              <div className="col-md-3">
                <Card
                  imgurl={require("../../images/internship.png")}
                  heading="Internship"
                  para="                      You will be stationed at Pune and the internship will last
                      for a period of 3 months which will give you an in-depth
                      experience of development"
                />
                <NavLink
                  to="/courses"
                  id="courseButton"
                  activeClassName="active"
                >
                  Courses details
                </NavLink>
              </div>
              <div className="col-md-3">
                <Card
                  imgurl={require("../../images/basic programming.png")}
                  heading="Basic"
                  para="Basic programming languages such as C and C++ programming,
                      core java Object oriented concepts,Datastructure
                      ,web development using HTML5 CSS3."
                />
                <NavLink
                  to="/courses"
                  id="courseButton"
                  activeClassName="active"
                >
                  Courses details
                </NavLink>
              </div>
              <div className="col-md-3">
                <Card
                  imgurl={require("../../images/Advance programming.png")}
                  heading="Advance"
                  para=" Interprise level application development using Advance
                      java and .Net framework ,Advance web
                      development technologies Angular,NodeJs.ASP."
                />
                <NavLink
                  to="/courses"
                  id="courseButton"
                  activeClassName="active"
                >
                  Courses details
                </NavLink>
              </div>
              <div className="col-md-3">
                <Card
                  imgurl={require("../../images/soft skills.png")}
                  heading="Popular Courses"
                  para="Red Hat Certified System Administrator,Red Hat
                      Certified Engineer, Red Hat Certified System
                      Administrator,Shell Scripting,
                    ,Red Hat OpenStack"
                />
                <NavLink
                  to="/courses"
                  id="courseButton"
                  activeClassName="active"
                >
                  Courses details
                </NavLink>
              </div>
            </div> */}
            <div className="row">
              <div className="col-md-3">
                <div className="courseBlock py-3 px-3">
                  <img src={require("../../images/internship.png")} alt="" />
                  <h3 className="text-left py-2">
                  Internship
                  </h3>
                  <p>
                    You will be stationed at Pune and the internship will last
                    for a period of 3 months which will give you an in-depth
                    experience of development
                  </p>
                  <NavLink
                    to="/courses"
                    id="courseButton"
                    activeClassName="active"
                  >
                    <button className="btn btn-primary btn-lg btn-block">
                      Courses details
                    </button>
                  </NavLink>
                </div>
              </div>

              <div className="col-md-3">
                <div className="courseBlock py-3 px-3">
                  <img
                    src={require("../../images/basic programming.png")}
                    alt=""
                  />
                  <h3 className="text-left py-2">
                  Basic
                  </h3>
                  <p >
                    Basic programming languages such as C and C++ programming,
                    core java Object oriented concepts,Datastructure ,web
                    development using HTML5 CSS3
                  </p>
                  <NavLink
                    to="/courses"
                    id="courseButton"
                    activeClassName="active"
                  >
                    <button className="btn btn-primary btn-lg btn-block">
                      Courses details
                    </button>
                  </NavLink>
                </div>
              </div>

              <div className="col-md-3">
                <div className="courseBlock py-3 px-3">
                  <img
                    src={require("../../images/Advance programming.png")}
                    alt=""
                  />
                                    <h3 className="text-left py-2">
                  Advance
                  </h3>
                  <p>
                    Interprise level application development using Advance java
                    and .Net framework ,Advance web development technologies
                    Angular,NodeJs.ASP
                  </p>
                  <NavLink
                    to="/courses"
                    id="courseButton"
                    activeClassName="active"
                  >
                    <button className="btn btn-primary btn-lg btn-block">
                      Courses details
                    </button>
                  </NavLink>
                </div>
              </div>

              <div className="col-md-3">
                <div className="courseBlock py-3 px-3">
                  <img src={require("../../images/soft skills.png")} alt="" />
                  <h3 className="text-left py-2">
                  Popular Courses
                  </h3>
                  <p >
                    Red Hat Certified System Administrator,Red Hat Certified
                    Engineer, Red Hat Certified System Administrator,Shell
                    Scripting, ,Red Hat OpenStack
                  </p>
                  <NavLink
                    to="/courses"
                    id="courseButton"
                    activeClassName="active"
                  >
                    <button className="btn btn-primary btn-lg btn-block">
                      Courses details
                    </button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* page3 */}
        <section className="page3">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="heading">
                  <h1>
                    Watch Our Trainers <br />
                    in Live Action
                  </h1>
                  <p>
                    Classes are fun to attend when you have dynamic and
                    energetic trainers for you!!!
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <Iframe
                  url="https://www.youtube.com/embed/T_Fe4IaG0KU"
                  width="100%"
                  height="500px"
                  id="myId"
                  className="myClassname"
                  display="initial"
                  allow="fullscreen"
                  position="relative"
                />
                <div className="videoHeading">
                  <h1>Learn Angular course with us</h1>
                  <p>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Sapiente, aut!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* page 4 */}
        <section className="page4">
          <div className="container">
            <div className="row">
              <div className="col-md-6">
                <div className="heading">
                  <p id="fact">TAKE A LOOK AT OUR</p>
                  <h1>Some Facts</h1>
                  <p>
                    At Logipool, we try to bring latest courses to students so
                    that they can stand out in crowd. Not only that we provide a
                    dedicated team to answer your questions.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-3 col-6">
                <div className="factSection">
                  <div className="imgSection">
                    <img src={require("../../images/Students.png")} alt="" />
                  </div>
                  <div className="info">
                    <CountUp end={25320} redraw={true} duration={3}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <h1 ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    <h3>Students</h3>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="factSection">
                  <div className="imgSection">
                    <img src={require("../../images/Placements.png")} alt="" />
                  </div>
                  <div className="info">
                    <CountUp end={5012} redraw={true} duration={3}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <h1 ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    <h3>Placements</h3>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="factSection">
                  <div className="imgSection">
                    <img
                      src={require("../../images/Campus drive.png")}
                      alt=""
                    />
                  </div>
                  <div className="info">
                    <CountUp end={108} redraw={true} duration={3}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <h1 ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    <h3>Campus drive</h3>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-6">
                <div className="factSection">
                  <div className="imgSection">
                    <img src={require("../../images/Workshops.png")} alt="" />
                  </div>
                  <div className="info">
                    {/* <h1>20120</h1> */}
                    <CountUp end={1097} redraw={true} duration={3}>
                      {({ countUpRef, start }) => (
                        <VisibilitySensor onChange={start} delayedCall>
                          <h1 ref={countUpRef} />
                        </VisibilitySensor>
                      )}
                    </CountUp>
                    <h3>Workshops</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Contact Us */}
        <section className="contact">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6">
                <div className="heading">
                  <h1>Contact Us</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 offset-md-2">
                <div className="contactSection">
                  <h1>Have any questions?</h1>
                  <h1>Give us call at :</h1>
                  <div className="contactNumber">
                    <img src={require("../../images/Call.png")} alt="" />
                    <h3>+91 9999 201 122</h3>
                  </div>
                </div>
              </div>
              <div className="col-md-4 offset-md-1">
                <div className="contactFormSection">
                  <div className="contactForm">
                    <form onSubmit={this.onSubmit}>
                      <div className="Forminput">
                        <label htmlFor="Email">Email *</label>
                        <input
                          type="email"
                          name="email"
                          id=""
                          value={email}
                          onChange={this.onChange}
                          placeholder="Enter you Email"
                        />
                      </div>
                      <div className="Forminput">
                        <label htmlFor="phone">Phone *</label>
                        <input
                          type="phone"
                          name="phone"
                          id=""
                          value={phone}
                          onChange={this.onChange}
                          placeholder="Enter you Phone Number"
                        />
                      </div>

                      <div className="btnSection">
                        <button type="submit">Contact Us</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Feefback */}
        <section className="feedback">
          <div className="container">
            <div className="row">
              <div className="heading">
                <h1>Feedback</h1>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-10 offset-md-1">
                <OwlCarousel
                  className="owl-theme"
                  loop
                  margin={10}
                  // nav
                  {...options}
                >
                  <div className="item">
                    <div className="cardBody">
                      <div className="headingSection">
                        <div className="avtar">
                          <img src={require("../../images/Avtar.png")} alt="" />
                        </div>
                        <div className="info">
                          <h1> Asif Shaikh</h1>
                          <p>DevOps Engineer</p>
                        </div>
                      </div>
                      <div className="contains">
                        <p>
                          This is the best place to learn Red hat Linux. Got
                          placed at Mithi Software’s through the call from
                          Logipool Infotech
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="cardBody">
                      <div className="headingSection">
                        <div className="avtar">
                          <img src={require("../../images/Avtar.png")} alt="" />
                        </div>
                        <div className="info">
                          <h1>Yogesh Desai</h1>
                          <p>AWS Solution Architect</p>
                        </div>
                      </div>
                      <div className="contains">
                        <p>
                          I have completed my RHCE from Logipool training
                          services, Aundh, and i found it to be one of the best
                          training services in Pune.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="cardBody">
                      <div className="headingSection">
                        <div className="avtar">
                          <img src={require("../../images/Avtar.png")} alt="" />
                        </div>
                        <div className="info">
                          <h1>Arjun</h1>
                          <p>Linux System Administrator</p>
                        </div>
                      </div>
                      <div className="contains">
                        <p>
                          Logipool training services provided excellent training
                          and well organized infrastructure and faculties are
                          always there to solve our problems.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="item">
                    <div className="cardBody">
                      <div className="headingSection">
                        <div className="avtar">
                          <img src={require("../../images/Avtar.png")} alt="" />
                        </div>
                        <div className="info">
                          <h1>Virendra Kadam</h1>
                          <p>student</p>
                        </div>
                      </div>
                      <div className="contains">
                        <p>
                          Logipool makes a difference in education and guiding
                          the people to achieve the desired goal.
                        </p>
                      </div>
                    </div>
                  </div>
                </OwlCarousel>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Home;
